'use client';
import { GroqImage } from '@/helpers/Image';
import { GROQButton, GROQImage } from '@/sanity/lib/definitions';
import { useIsMobile } from '@/hooks/useIsMobile';
import { richTextComponent } from '@/sanity/sanityPortableText';
import { motion } from 'framer-motion';
import { PortableText } from 'next-sanity';
import { PortableTextBlock } from 'sanity';
import { CTAButton } from '@/shadcn/ui/button';

interface IArchiteture {
  title: PortableTextBlock[];
  image: GROQImage;
  imageMobile: GROQImage;
  button: GROQButton;
}

export default function ArchitetureSection({
  title,
  image,
  imageMobile,
  button,
}: IArchiteture) {
  const isMobile = useIsMobile();

  return (
    <section id="architeture-section" className="container lg:max-w-none flex flex-col min-h-[111rem] lg:min-h-[135rem] lg:px-[8.12rem] pt-[9rem] lg:pt-[10.25rem] overflow-clip relative">
      <motion.div
        initial={{ clipPath: 'inset(0% 0% 100% 0%)' }}
        whileInView={{ clipPath: 'inset(0% 0% 0% 0%)' }}
        transition={{ duration: 1.5, ease: [0.25, 1, 0.5, 1] }}
        className="flex relative z-10 w-full lg:w-[52.5rem] flex-col gap-[2rem] lg:gap-[2.5rem]
        prose-headings:text-[4rem] lg:prose-headings:text-[6rem] prose-headings:text-[#DADADA] prose-headings:font-[200] prose-headings:uppercase prose-headings:leading-[115%]
        prose-p:text-[2rem] prose-p:text-[#DADADA] prose-p:font-[300] prose-p:leading-[160%]"
      >
        {title && (
          <PortableText value={title} components={richTextComponent} />
        )}

        <div className="flex justify-end lg:justify-start w-full lg:w-auto">
          <CTAButton data={button} />
        </div>
      </motion.div>

      <div className="w-full absolute z-0 inset-0 pointer-events-none select-none">
        {image && (
          <GroqImage
            src={isMobile ? imageMobile : image}
            alt={image?.name}
            className="!w-full !h-full !object-cover relative z-0"
            loading="eager"
            quality={100}
          />
        )}
      </div>
    </section>
  );
}
